import { ImageType, ProductType } from '@/shared/enums';

const typeToSubtitle = new Map([
  [ProductType.VOD, ['year', 'category']],
  [ProductType.PROGRAMME, 'sinceDate'],
  [ProductType.CLIP, 'sinceTime'],
  [ProductType.EPISODE, ['seriesFormat', 'duration']],
  ['verticalDefault', 'category'],
]);

export default {
  computed: {
    subtitleKeys() {
      const isVertical = this.imageType === ImageType.POSTER;
      return isVertical ? typeToSubtitle.get('verticalDefault') : typeToSubtitle.get(this.product.type);
    },
  },
};
